define('SageDotCom/DataLayer/Events/InterceptPanel',["jquery", "SageDotCom/DataLayer/Events/eventBase"],
    function ($, EventBase) {
        function InterceptPanel(eventName, eventLabel, componentId) {
            EventBase.call(this);

            this.props = {
                'event_action': eventName,
                'event_category': "component",
                'event_label': eventLabel,
                'event_nonint': 1
            };

            if (componentId) {
                const component = $('#' + componentId);
                const personalized = component.attr("data-attr-personalized");

                if (component.length > 0 && personalized === "true") {
                    const testId = component.attr("data-attr-test-id");
                    const testValue = component.attr("data-attr-test-value");

                    if (testId && testValue) {
                        this.props[testId] = testValue;
                    }
                }
            }
        }

        InterceptPanel.prototype = Object.create(EventBase.prototype);
        return InterceptPanel;
    });

